import styled from 'styled-components';
import { select } from '../../core/themev2';
import { getColor } from '../../core/themev3';

const SwitchContainer = styled.div`
  width: ${({ width }) => width};
  input:checked + .switch-label {
    background-color: ${getColor('primary')};
  }
`;

const SwitchInput = styled.input`
  height: 0;
  width: 0;
  visibility: hidden;
`;

const SwitchLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  width: 40px;
  height: 24px;
  border-radius: 100px;
  position: relative;
  transition: background-color 0.01s;
  background-color: ${select('middleGray')};
  margin-bottom: 20px;
`;

const SwitchButton = styled.span`
  content: '';
  position: absolute;
  left: 2px;
  width: 20px;
  height: 20px;
  border-radius: 45px;
  transition: 0.02s;
  background: ${select('white')};
  box-shadow: 0 0 2px 0 rgba(10, 10, 10, 0.29);
  ${SwitchInput}:checked + ${SwitchLabel} & {
    left: calc(100% - 2px);
    transform: translateX(-100%);
  }
`;

export { SwitchContainer, SwitchInput, SwitchLabel, SwitchButton };
